import { validator } from "@/utils/validator";

export const nationalitySchema = validator.object().shape({
  regionId: validator.string().trim().emptyToNull().label("地域").required(),
  nationalityName: validator.string().trim().emptyToNull().label("名称").required(),
  engNationalityName: validator.string().trim().emptyToNull().latinsOnly().label("名称（英語）").required(),
});

export const masterDataCreateRegionSchema = validator.object().shape({
  regionName: validator.string().trim().emptyToNull().label("地域").required(),
  nationalities: validator.array().of(nationalitySchema).label("nationality").required(),
});

export const masterDataUpdateRegionSchema = validator.object().shape({
  regionName: validator.string().trim().emptyToNull().label("地域").required(),
});
